import { GetServerSideProps } from "next"
import { useTranslation, withTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Params } from "next/dist/shared/lib/router/utils/route-matcher"
import React, { Fragment } from "react"

const Chinhsachgiaohang = () => {
  return (
    <div className="other-page-style mt-[80px]">
      <>
        <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '\n      @import url(https://themes.googleusercontent.com/fonts/css?kit=ZWjJg3Z-BmxuodZeCNuZK1XXWJorhxyFDZ_kYLKF3KU);\n      ol {\n        margin: 0;\n        padding: 0;\n      }\n      table td,\n      table th {\n        padding: 0;\n      }\n      .c10 {\n        border-right-style: solid;\n        border-top-width: 0pt;\n        border-right-width: 0pt;\n        padding-left: 0pt;\n        border-left-width: 0pt;\n        border-top-style: solid;\n        background-color: #ffffff;\n        border-left-style: solid;\n        border-bottom-width: 0pt;\n        border-bottom-style: solid;\n        padding-right: 0pt;\n      }\n      .c4 {\n        border-right-style: solid;\n        padding: 5pt 5pt 5pt 5pt;\n        border-bottom-color: #000000;\n        border-top-width: 1pt;\n        border-right-width: 1pt;\n        border-left-color: #000000;\n        vertical-align: top;\n        border-right-color: #000000;\n        border-left-width: 1pt;\n        border-top-style: solid;\n        border-left-style: solid;\n        border-bottom-width: 1pt;\n        width: 154.5pt;\n        border-top-color: #000000;\n        border-bottom-style: solid;\n      }\n      .c5 {\n        border-right-style: solid;\n        padding: 5pt 5pt 5pt 5pt;\n        border-bottom-color: #000000;\n        border-top-width: 1pt;\n        border-right-width: 1pt;\n        border-left-color: #000000;\n        vertical-align: top;\n        border-right-color: #000000;\n        border-left-width: 1pt;\n        border-top-style: solid;\n        border-left-style: solid;\n        border-bottom-width: 1pt;\n        width: 135pt;\n        border-top-color: #000000;\n        border-bottom-style: solid;\n      }\n      .c7 {\n        color: #100d28;\n        font-weight: 400;\n        text-decoration: none;\n        vertical-align: baseline;\n        font-size: 12pt;\n        font-family: "Nunito";\n        font-style: normal;\n      }\n      .c3 {\n        color: #100d28;\n        font-weight: 700;\n        text-decoration: none;\n        vertical-align: baseline;\n        font-size: 12pt;\n        font-family: "Nunito";\n        font-style: normal;\n      }\n      .c19 {\n        padding-top: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      .c2 {\n        padding-top: 0pt;\n        padding-bottom: 10pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: center;\n      }\n      .c1 {\n        padding-top: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: justify;\n      }\n      .c0 {\n        padding-top: 10pt;\n        padding-bottom: 10pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: justify;\n      }\n      .c6 {\n        font-size: 12pt;\n        font-family: "Nunito";\n        color: #100d28;\n        font-weight: 700;\n      }\n      .c13 {\n        border-spacing: 0;\n        border-collapse: collapse;\n        margin-right: auto;\n      }\n      .c9 {\n        padding-top: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1;\n        text-align: center;\n      }\n      .c14 {\n        text-decoration: none;\n        vertical-align: baseline;\n        font-size: 11pt;\n        font-style: normal;\n      }\n      .c17 {\n        background-color: #ffffff;\n        max-width: 468pt;\n        padding: 72pt 72pt 72pt 72pt;\n      }\n      .c11 {\n        font-family: "Nunito";\n        color: #100d28;\n        font-weight: 400;\n      }\n      .c20 {\n        color: #000000;\n        font-weight: 400;\n        font-family: "Arial";\n      }\n      .c12 {\n        font-style: italic;\n      }\n      .c18 {\n        font-size: 12pt;\n      }\n      .c16 {\n        height: 0pt;\n      }\n      .c15 {\n        page-break-after: avoid;\n      }\n      .c8 {\n        height: 11pt;\n      }\n      .title {\n        padding-top: 0pt;\n        color: #000000;\n        font-size: 26pt;\n        padding-bottom: 3pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      .subtitle {\n        padding-top: 0pt;\n        color: #666666;\n        font-size: 15pt;\n        padding-bottom: 16pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      li {\n        color: #000000;\n        font-size: 11pt;\n        font-family: "Arial";\n      }\n      p {\n        margin: 0;\n        color: #000000;\n        font-size: 11pt;\n        font-family: "Arial";\n      }\n      h1 {\n        border-right-style: solid;\n        color: #2e2e2e;\n        border-top-width: 0pt;\n        font-weight: 700;\n        padding-left: 0pt;\n        font-size: 12pt;\n        background-color: #ffffff;\n        border-left-style: solid;\n        font-family: "Times New Roman";\n        orphans: 2;\n        text-align: justify;\n        padding-top: 0pt;\n        border-right-width: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1.15;\n        page-break-after: avoid;\n        border-left-width: 0pt;\n        border-top-style: solid;\n        border-bottom-width: 0pt;\n        border-bottom-style: solid;\n        widows: 2;\n        padding-right: 0pt;\n      }\n      h2 {\n        padding-top: 18pt;\n        color: #000000;\n        font-size: 16pt;\n        padding-bottom: 6pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h3 {\n        padding-top: 16pt;\n        color: #434343;\n        font-size: 14pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h4 {\n        padding-top: 14pt;\n        color: #666666;\n        font-size: 12pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h5 {\n        padding-top: 12pt;\n        color: #666666;\n        font-size: 11pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h6 {\n        padding-top: 12pt;\n        color: #666666;\n        font-size: 11pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        font-style: italic;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n    '
          }}
        />
        <div>
          <p className="c8 c19">
            <span className="c14 c20" />
          </p>
        </div>
        <p className="c2">
          <span className="c3">CHÍNH SÁCH GIAO HÀNG</span>
        </p>
        <h1 className="c10 c1 c15" id="h.p5aaqaporeq">
          <span className="c3">1. PHƯƠNG THỨC GIAO HÀNG</span>
        </h1>
        <p className="c1 c10">
          <span className="c3">
            Giao hàng tại địa chỉ mà khách hàng yêu cầu
          </span>
        </p>
        <p className="c10 c1 mb-4">
          <span className="c11 c18">Playee</span>
          <span className="c7">
            &nbsp;phục vụ giao hàng cho Khách hàng trên toàn quốc, ngoại trừ một
            số khu vực sau: Xã Hoàng Sa (Huyện Hoàng Sa, Đà Nẵng), Xã Trường Sa,
            Xã Song Tử Tây, Xã Sinh Tồn (Huyện Trường Sa, Khánh Hòa), Xã An Sơn,
            Xã Hòn Tre, Xã Lại Sơn, Xã Nam Du (Huyện Kiên Hải, Kiên Giang),
            Huyện Bảo Lâm (Lâm Đồng), Huyện Phú Quí (Bình Thuận).
          </span>
        </p>
        <h1 className="c10 c1 c15" id="h.179x9q6125tz">
          <span className="c3">2. PHÍ &amp; THỜI GIAN GIAO HÀNG ƯỚC TÍNH</span>
        </h1>
        <a id="t.5b29feafb1805a0062550e15144d16bdfed45bbb" />
        <a id="t.0" />
        <table className="c13">
          <tbody>
            <tr className="c16">
              <td className="c4" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c3">Tuyến</span>
                </p>
              </td>
              <td className="c5" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c3">Thời gian giao hàng</span>
                </p>
              </td>
              <td className="c4" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c3">Cước phí dự tính</span>
                </p>
              </td>
            </tr>
            <tr className="c16">
              <td className="c4" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c7">Nội tỉnh (Hà Nội)</span>
                </p>
              </td>
              <td className="c5" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c7">2-4 ngày</span>
                </p>
              </td>
              <td className="c4" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c7">30,000</span>
                </p>
              </td>
            </tr>
            <tr className="c16">
              <td className="c4" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c7">Các tình thành khác</span>
                </p>
              </td>
              <td className="c5" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c7">5-7 ngày</span>
                </p>
              </td>
              <td className="c4" colSpan={1} rowSpan={1}>
                <p className="c9">
                  <span className="c7">50,000</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="c0">
          <span className="c6 c12">
            Lưu ý: Phí giao hàng có thể thay đổi tùy vào trọng lượng kiện hàng
            sau khi đóng gói
          </span>
        </p>
        <p className="c10 c1">
          <span className="c6">Thời gian phục vụ giao hàng</span>
          <span className="c7">
            : Playee phục vụ giao hàng trong giờ hành chính thứ 2 đến thứ 7 (trừ
            Chủ nhật và ngày Lễ, Tết). Trong trường hợp, quý khách đặt hàng sau
            18h, thời gian giao hàng sẽ cộng dồn thêm 1 ngày.
          </span>
        </p>
        <p className="c10 c1">
          <span className="c6">Thời gian giao hàng:</span>
          <span className="c7">&nbsp;Trung bình từ 3-5 ngày làm việc.</span>
        </p>
        <p className="c0">
          <span className="c7">
            Đơn hàng sẽ được giao đến địa chỉ của khách hàng, ngoại trừ các
            trường hợp như: khu vực văn phòng hạn chế ra vào, khu vực chung
            cư/cao tầng (chỉ phục vụ giao tại chân tòa nhà) hoặc bên trong các
            khu vực hạn chế đi lại (khu vực quân sự, biên giới,…).
          </span>
        </p>
        <h1 className="c10 c1 c15" id="h.ha3ipp5ryr9g">
          <span className="c3">3. PHÂN ĐỊNH TRÁCH NHIỆM CÁC BÊN</span>
        </h1>
        <p className="c0">
          <span className="c3">3.1. Nghĩa vụ của bên vận chuyển</span>
        </p>
        <p className="c1">
          <span className="c7">
            - Bảo đảm vận chuyển tài sản đầy đủ, an toàn đến địa điểm đã định,
            theo đúng thời hạn.
          </span>
        </p>
        <p className="c1">
          <span className="c7">- Giao tài sản cho người có quyền nhận.</span>
        </p>
        <p className="c1">
          <span className="c7">
            - Chịu chi phí liên quan đến việc chuyên chở tài sản, trừ trường hợp
            có thỏa thuận khác.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Mua bảo hiểm trách nhiệm dân sự theo quy định của pháp luật.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Bồi thường thiệt hại cho bên thuê vận chuyển trong trường hợp bên
            vận chuyển để mất, hư hỏng tài sản, trừ trường hợp có thỏa thuận
            khác hoặc pháp luật có quy định khác.
          </span>
        </p>
        <p className="c1 c8">
          <span className="c7" />
        </p>
        <p className="c1">
          <span className="c11 c18">&nbsp;</span>
          <span className="c6">3.2. Quyền của bên vận chuyển</span>
        </p>
        <p className="c1">
          <span className="c7">
            - Kiểm tra sự xác thực của tài sản, của vận đơn hoặc chứng từ vận
            chuyển tương đương khác.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Từ chối vận chuyển tài sản không đúng với loại tài sản đã thỏa
            thuận trong hợp đồng.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Yêu cầu bên thuê vận chuyển thanh toán đủ cước phí vận chuyển đúng
            thời hạn.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Từ chối vận chuyển tài sản cấm giao dịch, tài sản có tính chất
            nguy hiểm, độc hại, nếu bên vận chuyển
          </span>
        </p>
        <p className="c1">
          <span className="c7">&nbsp;</span>
        </p>
        <p className="c0">
          <span className="c6">3.3. Nghĩa vụ của bên thuê vận chuyển</span>
        </p>
        <p className="c1">
          <span className="c7">
            - Trả đủ tiền cước phí vận chuyển cho bên vận chuyển theo đúng thời
            hạn, phương thức đã thỏa thuận.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Cung cấp thông tin cần thiết liên quan đến tài sản vận chuyển để
            bảo đảm an toàn cho tài sản vận chuyển.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Trông coi tài sản trên đường vận chuyển, nếu có thỏa thuận. Trường
            hợp bên thuê vận chuyển trông coi tài sản mà tài sản bị mất, hư hỏng
            thì không được bồi thường.
          </span>
        </p>
        <p className="c1">
          <span className="c7">&nbsp;</span>
        </p>
        <p className="c0">
          <span className="c6">3.4. Nghĩa vụ của bên thuê vận chuyển</span>
        </p>
        <p className="c1">
          <span className="c7">
            - Yêu cầu bên vận chuyển chuyên chở tài sản đến đúng địa điểm, thời
            điểm đã thỏa thuận.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Trực tiếp hoặc chỉ định người thứ ba nhận lại tài sản đã thuê vận
            chuyển.
          </span>
        </p>
        <p className="c1">
          <span className="c7">&nbsp;</span>
        </p>
        <p className="c1">
          <span className="c3">3.5. Trách nhiệm bồi thường thiệt hại</span>
        </p>
        <p className="c1">
          <span className="c7">
            - Bên vận chuyển phải bồi thường thiệt hại cho bên thuê vận chuyển
            nếu để tài sản bị mất hoặc hư hỏng.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Bên thuê vận chuyển phải bồi thường thiệt hại cho bên vận chuyển
            và người thứ ba về thiệt hại do tài sản vận chuyển có tính chất nguy
            hiểm, độc hại mà không có biện pháp đóng gói, bảo đảm an toàn trong
            quá trình vận chuyển.
          </span>
        </p>
        <p className="c1">
          <span className="c7">
            - Trường hợp bất khả kháng dẫn đến tài sản vận chuyển bị mất, hư
            hỏng hoặc bị hủy hoại trong quá trình vận chuyển thì bên vận chuyển
            không phải chịu trách nhiệm bồi thường thiệt hại, trừ trường hợp có
            thỏa thuận khác hoặc pháp luật có quy định khác.
          </span>
        </p>
        <p className="c1 c8">
          <span className="c7" />
        </p>
        <h1 className="c10 c1 c15" id="h.sqc8aia2yxe5">
          <span className="c3">4. BẤT KHẢ KHÁNG</span>
        </h1>
        <p className="c10 c1">
          <span className="c7">
            Trong các trường hợp có phát sinh dịch bệnh (Covid, SARS, …), thiên
            tai hoặc trong các trường hợp bất khả kháng tại thời điểm phát sinh
            theo quy định của cơ quan quản lý nhà nước, việc giao hàng sẽ thay
            đổi theo tình hình thực tế về quy định chuyển phát hàng hoá của nhà
            nước, Playee được quyền từ chối giao hàng.
          </span>
        </p>
        <p className="c10 c1 mb-8">
          <span className="c7">
            Trường hợp phát sinh chậm trễ trong việc giao hàng và cung ứng dịch
            vụ, Playee sẽ có thông báo kịp thời cho khách hàng và tạo cơ hội để
            khách hàng có thể hủy hợp đồng nếu muốn.
          </span>
        </p>
        <p className="c1 c8">
          <span className="c11 c14" />
        </p>
      </>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  locale
}: Params) => {
  return {
    props: {
      isShowSidebar: false,
      isShowTrending: false,
      isShowBottomBar: false,
      ...(await serverSideTranslations(locale, ["common"]))
    }
  }
}

export default withTranslation("common")(Chinhsachgiaohang)
